import { Hammer, Car, Home, Wrench, Cpu, PawPrint } from "lucide-react";

export const PUBLIC_CATEGORIES = [
  { key: "building", icon: Hammer },
  { key: "car", icon: Car },
  { key: "household", icon: Home },
  { key: "tools", icon: Wrench },
  { key: "electronics", icon: Cpu },
  { key: "pets", icon: PawPrint },
];

export const CONTACT_EMAIL = "support@drivons.com";
